module.exports = __webpack_public_path__ + "static/media/create_reservation_select_room.6cf31d90.jpg";